/**
 * 站点跟域名
 */
enum WebSite {
  Akulaku = ".akulaku.com",
  Silvrrplus = ".silvrrplus.com",
  Silvrr = ".silvrr.com",
  Wisecart = ".wisecartapp.com",
}

export default WebSite;
